var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0765 21.1965H16.3257V17.5951C17.7089 17.5951 19.0438 17.1918 20.1827 16.4306C22.1198 15.1355 23.2757 12.9741 23.2757 10.6451C23.2757 9.81003 23.1281 8.99204 22.8412 8.21666L22.026 6.024L24.355 5.79678C24.5964 5.77406 24.8322 5.7627 25.0765 5.7627C29.334 5.7627 32.7962 9.2221 32.7962 13.4768C32.7962 17.7343 29.334 21.1965 25.0765 21.1965ZM24.267 17.5951H25.0765C27.3486 17.5951 29.1948 15.7461 29.1948 13.4768C29.1948 11.838 28.2291 10.4207 26.8402 9.75891C26.8658 10.0543 26.8772 10.3497 26.8772 10.6451C26.8772 13.2382 25.9314 15.695 24.267 17.5951Z",
    fill: "url(#paint0_linear_1712_107860)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3257 21.2847H7.80497C3.50202 21.2847 0 17.7827 0 13.4769C0 9.48355 3.01349 6.1832 6.88473 5.72592C8.70248 2.25515 12.3494 0 16.3257 0C20.7479 0 24.7555 2.78343 26.2978 6.92734C26.7408 8.1174 26.9652 9.3671 26.9652 10.6424C26.9652 14.204 25.1957 17.5129 22.2334 19.4954C20.4866 20.6684 18.4417 21.2847 16.3257 21.2847ZM7.80497 9.45231C5.58675 9.45231 3.78035 11.2587 3.78035 13.4769C3.78035 15.698 5.58675 17.5072 7.80497 17.5072H16.3257C17.6918 17.5072 19.0069 17.1096 20.1316 16.3569C22.0431 15.0788 23.1849 12.943 23.1849 10.6452C23.1849 9.82154 23.04 9.01491 22.756 8.24805C21.7619 5.57538 19.1773 3.78036 16.3257 3.78036C13.4798 3.78036 10.8952 5.5697 9.89823 8.23385L9.41823 9.51763L8.04923 9.46083C7.9697 9.45515 7.88734 9.45231 7.80497 9.45231Z",
    fill: "url(#paint1_linear_1712_107860)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1712_107860",
    x1: 16.3261,
    y1: 13.479,
    x2: 32.7954,
    y2: 13.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3439,
    stopColor: "#034EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#0C61AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5772,
    stopColor: "#2280C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7137,
    stopColor: "#309CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#3BB2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9335,
    stopColor: "#43C1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C8F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1712_107860",
    x1: 0.00144852,
    y1: 10.6435,
    x2: 26.9665,
    y2: 10.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1428,
    stopColor: "#034EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2541,
    stopColor: "#0C61AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    stopColor: "#2280C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259,
    stopColor: "#309CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7831,
    stopColor: "#3BB2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9132,
    stopColor: "#43C1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C8F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.4d7c76b3a6a2ab88f9ce18c5a115ee28.svg";
export { ForwardRef as ReactComponent };